<svg width="200" height="200" class="circle-rotate">
  <circle cx="100" cy="100" r="80" [attr.stroke]="circleBackColor" stroke-width="30" fill="none"></circle>

  <circle cx="100" cy="100" r="80" stroke-linecap="round" [attr.stroke]="circleColor" stroke-width="28" fill="none"
    [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="dashOffset">
  </circle>

</svg>
<div class="text-container">
  <div class="circle-count">
    {{count}}
  </div>
  <div class="circle-text">
    {{circleText}}
  </div>
</div>
